const allBlogs = [
  {
    id: 1,
    img: "https://images.unsplash.com/photo-1547586696-ea22b4d4235d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
    category: "article",
    title: "Boost your conversion rate",
    author_img:
      "https://yt3.ggpht.com/ytc/AMLnZu_92YKnhvarB3MBxCPK9fggv3AjQAhkjaEIz_QOkA=s900-c-k-c0x00ffffff-no-rj",
    author_name: "Design Course",
    time: "8 Feb, 2022",
    read: "11 min read",
  },
  {
    id: 2,
    img: "https://cdn.searchenginejournal.com/wp-content/uploads/2022/03/traditional-to-enterprise-seo-6229f8159834d-sej-760x400.png",
    category: "SEO",
    title: "How to use search engine optimization to drive sales",
    author_img: "https://avatars.githubusercontent.com/u/73503432?v=4",
    author_name: "Learn With Sumit",
    time: "8 Feb, 2022",
    read: "11 min read",
  },
  {
    id: 3,
    img: "https://www.quickhr.biz/wp-content/uploads/2017/08/Improve.jpg",
    category: "Technical",
    title: "Improve your customer experience",
    author_img: "https://avatars.githubusercontent.com/u/73503432?v=4",
    author_name: "Learn With Sumit",
    time: "8 Feb, 2022",
    read: "11 min read",
  },
  {
    id: 4,
    img: "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
    category: "Technical",
    title: "Boost your conversion rate",
    author_img:
      "http://www.studywithanis.com/wp-content/uploads/2017/01/logo.png",
    author_name: "Anisul Islam",
    time: "8 Feb, 2022",
    read: "11 min read",
  },
  {
    id: 5,
    img: "https://images.unsplash.com/photo-1547586696-ea22b4d4235d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
    category: "article",
    title: "Improve your customer experience",
    author_img:
      "https://play-lh.googleusercontent.com/edmBVFMS9fhuZycs2I6jCO7vGxhH434upOADR2e3x5Wi_s6Et4vcFY0gYs0q_B0qFS8",
    author_name: "Jhonkar Mahbub",
    time: "8 Feb, 2022",
    read: "11 min read",
  },
  {
    id: 6,
    img: "https://cdnwp.mobidea.com/academy/wp-content/uploads/2018/04/best-seo-training-courses-760x428-1.png",
    category: "SEO",
    title: "For selling drive How to use search engine optimization",
    author_img: "https://avatars.githubusercontent.com/u/73503432?v=4",
    author_name: "Learn With Sumit",
    time: "8 Feb, 2022",
    read: "11 min read",
  },
  {
    id: 7,
    img: "https://images.unsplash.com/photo-1547586696-ea22b4d4235d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
    category: "article",
    title: "Improve your customer experience",
    author_img:
      "http://www.studywithanis.com/wp-content/uploads/2017/01/logo.png",
    author_name: "Anisul Islam",
    time: "8 Feb, 2022",
    read: "11 min read",
  },
];

export default allBlogs;
